<template>
  <v-sheet class="container">
    <v-card class="ma-3">
      <v-card-title>Edit Profile</v-card-title>
      <v-card-text>
        <v-text-field
          v-model="firstName"
          label="First Name"
          :rules="[rules.required]"
          required
        ></v-text-field>
        <v-text-field
          v-model="lastName"
          label="Last Name"
          :rules="[rules.required]"
          required
        ></v-text-field>
        <v-text-field
          :disabled="true"
          v-model="email"
          label="Email"
          :rules="[rules.emailMatch]"
          required
        ></v-text-field>
      </v-card-text>
      <v-card-actions>
          <v-spacer/>
          <v-btn @click="updateProfile" color="primary" class="mb-5">
              Update
          </v-btn>
          <v-spacer/>
      </v-card-actions>
    </v-card>
    <reset-password />
  </v-sheet>
</template>

<script>
import { mapActions } from "vuex";
import { rules } from "@/store/util/rules.js";
const ResetPassword = () => import("@/components/user/ResetPassword.vue");
import { mapGetters } from "vuex";


export default {
  components: {
    ResetPassword,
  },
  computed:{
    ...mapGetters("auth", ["isLoggedIn", "currentUser"]),
    ...mapGetters("navigation", ["isAppLoading", "globalCenter"]),  },
  mounted() {
      if(this.isLoggedIn && this.currentUser){
          this.firstName = this.currentUser.firstName;
          this.lastName = this.currentUser.lastName;
          this.email = this.currentUser.email;
      }
  },
  data: () => {
    return {
      firstName: null,
      lastName: null,
      email: null,
      rules,
    };
  },
  methods:{
    ...mapActions("messages", ["addErrorMessage", "addSuccessMessage", "clearMessage"]),
    updateProfile(){
      const data = {
          email: this.email,
          firstName: this.firstName,
          lastName: this.lastName
      }
      this.$axios.post('/user/change-profile', data)
        .then(() => {
          this.addSuccessMessage('Profile updated')
          const user = this.currentUser;
          user.firstName = this.firstName;
          user.lastName = this.lastName;
          user.email = this.email;
        })
        .catch(() => {
          this.addErrorMessage('Error updating profile')
        })
    }
  }
};
</script>

<style>
</style>